import axios, { AxiosRequestConfig } from 'axios';
import Swal from 'sweetalert2';

import { StorageEnum } from '../enumerators/Storage.enum';

import { getInstance } from './axios-instance';

const B2C = 919;
const SYSMO_PROJECTS = 1080;

const SYSMO_CLIENTS = ['homologacao', 'qualidade9980', 'qualidade9981', 'servico', 'qualidadegcp', 'qualidadegcp2'];
const IGNORED_CLIENTS = ['debug', 'coagrisol', 'kiko', 'economia', 'divinaterra', 'atraente', 'riogrande', 'steidel'];

async function getTags() {
	const tagsv60 = await getTagsv60();
	const tagsv2 = await getTagsv2();
	return [...tagsv2, ...tagsv60];
}

async function getTagsv60() {
	const url = `/projects/${B2C}/repository/tags?order_by=name&sort=desc&search=^1.00.60.`;
	let request;

	request = await getInstance().get(url);

	let tags: Array<any> = request.data;

	tags = tags.sort(function (a, b) {
		a = Number(a.name.replaceAll('.', ''));
		b = Number(b.name.replaceAll('.', ''));

		if (a < b) {
			return 1;
		}
		if (a > b) {
			return -1;
		}
		return 0;
	});

	return tags.slice(0, 5);
}

async function getTagsv2() {
	const url = `/projects/${B2C}/repository/tags?order_by=name&sort=desc&search=^2.0`;
	let request;

	request = await getInstance().get(url);

	let tags: Array<any> = request.data;

	tags = tags.sort(function (a, b) {
		a = Number(a.name.replaceAll('.', ''));
		b = Number(b.name.replaceAll('.', ''));

		if (a < b) {
			return 1;
		}
		if (a > b) {
			return -1;
		}
		return 0;
	});

	return tags.slice(0, 15);
}

async function getBranches() {
	const url = `/projects/${B2C}/repository/branches?per_page=100`;
	let request = await getInstance().get(url);

	let branches: Array<any> = request.data;
	branches.sort((a, b) => Number(a.name) - Number(b.name));
	return branches;
}

async function validateUser(userId: string) {
	const url = `/groups/${SYSMO_PROJECTS}/members/${userId}`;
	let request = await getInstance().get(url);
	return request.data;
}

async function getClients(ref: string, android = false) {
	const url = `/projects/${B2C}/repository/files/hooks%2Fclientes.json?ref=${encodeURIComponent(ref)}`;
	let request = await getInstance().get(url);

	let file: any = request.data;
	const clientsObject = JSON.parse(atob(file.content));
	let clientsList = Object.keys(clientsObject);

	clientsList = clientsList.filter((x) => !IGNORED_CLIENTS.includes(x));

	clientsList = clientsList.sort(function (a, b) {
		if (a < b) {
			return -1;
		}
		if (a > b) {
			return 1;
		}
		return 0;
	});

	const urlSequential = `/projects/${B2C}/repository/files/hooks%2Fconfig%2Ejson?ref=${encodeURIComponent(ref)}`;
	let requestSequential = await getInstance().get(urlSequential);

	const sequential: any = JSON.parse(atob(requestSequential.data.content));

	let sequencialBuild = sequential.config[android ? 'SEQUENCIAL_ANDROID' : 'SEQUENCIAL_IOS'];

	return {
		clients: clientsList,
		sequential: sequencialBuild,
		version: sequential.config.VERSAO,
	};
}

async function checkFastfileExists(ref: string, android = false) {
	try {
		const url = `/projects/${B2C}/repository/files/fastlane%2FFastfile?ref=${encodeURIComponent(ref)}`;
		let request = await getInstance().get(url);

		return request.status == 200;
	} catch (e) {
		return false;
	}
}

function sendBuildAndroid(clients: Array<string>, target: string, sequential: string, version: string, releaseNotes: string, automaticRelease: boolean, skipDeploy: boolean, fastfileExists: boolean) {
	clients.forEach(async (client) => {
		var bodyFormData = new FormData();
		bodyFormData.append('token', String(localStorage.getItem(StorageEnum.GITLAB_PIPELINE_TOKEN)));
		bodyFormData.append('ref', target);
		bodyFormData.append('variables[RUN]', 'true');
		bodyFormData.append('variables[CLIENTE]', client);
		bodyFormData.append('variables[VERSAO]', version);
		bodyFormData.append('variables[SKIP_DEPLOY]', !!skipDeploy ? 'true' : 'false');


		if (fastfileExists) {
			if (!skipDeploy) {
				bodyFormData.append('variables[AUTOMATIC_RELEASE]', !!automaticRelease ? 'true' : 'false');

				if (releaseNotes) {
					bodyFormData.append('variables[RELEASE_NOTES]', releaseNotes);
				}
			}
		}

		if (sequential) {
			sequential = sequential.replace(/[^0-9]/g, '');
			bodyFormData.append('variables[SEQUENCIAL]', sequential);
		}

		const params: AxiosRequestConfig = {
			data: bodyFormData,
			method: 'post',
			url: `${window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS}/projects/${B2C}/trigger/pipeline`,
			headers: { 'Content-Type': 'multipart/form-data' },
		};

		const response = await axios(params);

		return response.status;
	});
}

async function getDataByIdList(packageIdList: string[], fromStore: boolean) {
	return axios({
		method: 'post',
		url: `${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/app/${fromStore ? 'fromStore' : 'fromCache'}`,
		timeout: 60 * 1000,
		data: {
			appIdList: packageIdList,
			lang: 'pt',
			country: 'br',
		},
	});
}

async function getGitlabJobs(): Promise<any[]> {
	const jobsArray: any[] = [];
	let page = 1;
	const perPage = 25; // Busca 25 por request

	while (jobsArray.length < 25) {
		// Configuração de parâmetros para a requisição
		const axiosParam: AxiosRequestConfig = {
			method: 'get',
			url: `${window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS}/projects/${B2C}/jobs`,
			headers: {
				'PRIVATE-TOKEN': `${localStorage.getItem(StorageEnum.GITLAB_PERSONAL_TOKEN)}`,
			},
			params: {
				page: page,
				per_page: perPage, // Buscar até 25 jobs por página
			},
		};

		// Faz a requisição para a API
		const res = await axios(axiosParam);
		const jobs = res.data;

		// Se não houver mais jobs, saia do loop
		if (!jobs.length) {
			break;
		}

		for (const job of jobs) {
			job.expired = new Date(job.artifacts_expire_at) < new Date();

			let storage = localStorage.getItem(`variables[${job.pipeline.id}]`);

			if (storage) {
				job.variables = JSON.parse(storage);
			} else {
				job.variables = await getPipelineVariables(job.pipeline.id);
				localStorage.setItem(`variables[${job.pipeline.id}]`, JSON.stringify(job.variables));
			}

			if (!job.variables) {
				job.variables = {};
			}
		}

		// Filtra os jobs para excluir aqueles com PLATFORM == 'web'
		const filteredJobs = jobs.filter((x: any) => x.variables.PLATFORM !== 'web');

		// Adiciona os jobs filtrados ao array jobsArray
		jobsArray.push(...filteredJobs);

		// Incrementa a página para a próxima iteração
		page += 1;
	}

	// Retorna até 25 registros
	return jobsArray.slice(0, 25);
}

async function getPipelineVariables(pipelineId: number) {
	try {
		const axiosParam: AxiosRequestConfig = {
			method: 'get',
			url: `${window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS}/projects/${B2C}/pipelines/${pipelineId}/variables`,
			headers: {
				'PRIVATE-TOKEN': `${localStorage.getItem(StorageEnum.GITLAB_PERSONAL_TOKEN)}`,
			},
		};
		const res = await axios(axiosParam);

		var variables: any = {};

		let variaveis = ['CLIENTE', 'SEQUENCIAL', 'VERSAO', 'PLATFORM', 'AUTOMATIC_RELEASE'];

		variaveis.forEach((variavel) => {
			const cliente = res.data.find((variable: any) => variable.key == variavel);

			if (cliente) {
				variables[variavel] = cliente.value;
			}
		});
		return variables;
	} catch (e) {
		return {
			"CLIENTE": "Erro",
			"VERSAO": "Erro"
		}
	}
}

async function getUser() {
	const url = `/user`;
	let request = await getInstance().get(url);

	return request.data;
}

function gitlabLogin() {
	localStorage.setItem(StorageEnum.CALLBACK_PAGE, document.location.pathname.replace('login', ''));

	window.open(
		`https://gitlab.sysmo.com.br/oauth/authorize?client_id=${window.RUNTIME_CONFIG.REACT_APP_GITLAB_APP_ID}&redirect_uri=${location.origin}/gitlab/callback&response_type=code&scope=read_repository+api`,
		'_self',
	);
}

async function getAccessToken(code: string) {
	return new Promise((res, rej) => {
		fetchWithTimeout(`${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APP_DATA}/gitlab/access-token`, {
			method: 'GET',
			headers: { code: code },
			timeout: 120 * 1000,
		})
			.then(async (response) => {
				var responseJson = await response.json();
				if (response.ok) {
					localStorage.setItem(StorageEnum.GITLAB_REFRESHTOKEN, responseJson.refresh_token);
					localStorage.setItem(StorageEnum.GITLAB_TOKEN, responseJson.access_token);
					res(true);
				} else {
					rej(response);
				}
			})
			.catch((e) => {
				rej(null);
			});
	});
}

async function gitlabRefreshToken(refreshToken: string) {
	const url = `
  https://gitlab.sysmo.com.br/oauth/token?client_id=${window.RUNTIME_CONFIG.REACT_APP_GITLAB_APP_ID}&refresh_token=${refreshToken}&grant_type=refresh_token&redirect_uri=${location.origin}/gitlab/callback
  `;
	let request = await axios.post(url);
	return request.data;
}

async function retryBuild(jobId: number, callback?: any) {
	const axiosParam: AxiosRequestConfig = {
		method: 'post',
		url: `${window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS}/projects/${B2C}/jobs/${jobId}/retry`,
		headers: {
			'PRIVATE-TOKEN': `${localStorage.getItem(StorageEnum.GITLAB_PERSONAL_TOKEN)}`,
		},
	};
	axios(axiosParam)
		.then((res) => {
			callback(res.data);
		})
		.catch((_) => {
			Swal.fire({
				icon: 'warning',
				title: 'Erro ao reexecutar',
				text: 'Esta build não pode ser reexecutada. Envie outra manualmente.',
			});
		});
}

async function cancelBuild(jobId: number, callback?: any) {
	const axiosParam: AxiosRequestConfig = {
		method: 'post',
		url: `${window.RUNTIME_CONFIG.REACT_APP_GITLAB_ADRESS}/projects/${B2C}/jobs/${jobId}/cancel`,
		headers: {
			'PRIVATE-TOKEN': `${localStorage.getItem(StorageEnum.GITLAB_PERSONAL_TOKEN)}`,
		},
	};
	axios(axiosParam)
		.then((res) => {
			callback(res.data);
		})
		.catch((_) => {
			Swal.fire({
				icon: 'warning',
				title: 'Erro ao cancelar',
				text: 'Esta build não pode ser cancelada.',
			});
		});
}

async function getClientsServers() {
	const url = `/projects/${B2C}/repository/files/hooks%2Fclientes%2Ejson?ref=master`;
	let request = await getInstance().get(url);

	let file: any = request.data;
	const clientsObject: any = JSON.parse(decodeURIComponent(escape(atob(file.content))));
	let clientsList = Object.keys(clientsObject);

	clientsList = clientsList.filter((client) => ![...SYSMO_CLIENTS, ...IGNORED_CLIENTS].includes(client));

	let clientsServers: any[] = [];

	clientsList.forEach((client) => {
		const clientObj: any = clientsObject[client];

		clientsServers.push({
			name: clientObj.NOME_APP,
			package: clientObj.NOME_PACOTE,
			serverUrl: clientObj.URL_ENDPOINT,
			status: null,
		});
	});

	clientsServers = clientsServers.sort(function (a, b) {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	});

	return clientsServers;
}

async function getPackageClientsMaster() {
	const url = `/projects/${B2C}/repository/files/hooks%2Fclientes%2Ejson?ref=master`;
	let request = await getInstance().get(url);

	let file: any = request.data;
	const clientsObject = JSON.parse(atob(file.content));
	let clientsList = Object.keys(clientsObject);

	clientsList = clientsList.filter((x) => !IGNORED_CLIENTS.includes(x) && !SYSMO_CLIENTS.includes(x));

	let clientsPackages: any[] = [];

	clientsList.forEach((client) => {
		const clientObj: any = clientsObject[client];

		if (!clientsPackages.some((x) => x.package == clientObj.NOME_PACOTE) && clientObj.IDENTIFICADOR_APP) {
			clientsPackages.push({
				name: clientObj.NOME_APP,
				package: clientObj.NOME_PACOTE,
				appleId: clientObj.IDENTIFICADOR_APP.replace(/\D/g, ''),
				version: null,
			});
		}
	});

	clientsPackages = clientsPackages.sort(function (a, b) {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	});

	return clientsPackages;
}

async function validateToken(callback: Function) {
	let tokenValid = false;

	const removeToken = () => {
		localStorage.removeItem(StorageEnum.GITLAB_TOKEN);
		localStorage.removeItem(StorageEnum.GITLAB_REFRESHTOKEN);
	};
	try {
		const user = await getUser();
		const validation = await validateUser(user.id);

		tokenValid = validation.state == 'active';

		if (!tokenValid) {
			removeToken();
		}
	} catch (e) {
		const refreshToken = localStorage.getItem(StorageEnum.GITLAB_REFRESHTOKEN);

		if (refreshToken) {
			try {
				const newTokenObject = await gitlabRefreshToken(refreshToken);

				localStorage.setItem(StorageEnum.GITLAB_TOKEN, newTokenObject.access_token);
				localStorage.setItem(StorageEnum.GITLAB_REFRESHTOKEN, newTokenObject.refresh_token);

				tokenValid = true;
			} catch (e) {
				tokenValid = false;
				removeToken();
			}
		} else {
			removeToken();
		}
	} finally {
		callback(tokenValid);
	}
}

async function fetchWithTimeout(resource: any, options: any) {
	const { timeout = 8000 } = options;

	const controller = new AbortController();
	const id = setTimeout(() => controller.abort(), timeout);
	const response = await fetch(resource, {
		...options,
		signal: controller.signal,
	});
	clearTimeout(id);
	return response;
}

export {
	cancelBuild,
	getBranches,
	getClients,
	getClientsServers,
	getDataByIdList,
	getGitlabJobs,
	getPackageClientsMaster,
	getPipelineVariables,
	getTags,
	getUser,
	getAccessToken,
	gitlabLogin,
	gitlabRefreshToken,
	retryBuild,
	sendBuildAndroid,
	validateToken,
	validateUser,
	checkFastfileExists,
};
